import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';

import { environment } from '@app/environment';
import { LanguagesService, LoggedUserService } from '@app/services';

class ApiResponse {
    data: any;
    error : any;
}

@Injectable({
  providedIn: 'root'
})
export class ApiService {

    constructor(
        private httpClient: HttpClient,
        private languagesService: LanguagesService,
        private loggedUserService: LoggedUserService
    ) { }
    
    get(url: string, params: any|null = null, withCredentials: boolean = true, headers: HttpHeaders = new HttpHeaders(), responseType: string = 'json'): Promise<ApiResponse>{
        return new Promise((resolve) => {
            let options:any = {};
            if(!params){
                params = {};
            }
            params.language = this.setParamLanguage();
            options.params = params;            
            
            if(withCredentials && !headers.has("Authorization")){
                if(!this.loggedUserService.jwtToken){
                    resolve({data: null, error: true});
                    return;
                }
                headers = headers.append("Authorization", "Bearer " + this.loggedUserService.jwtToken);
            }
            headers = headers.append("X-APP-CODE","locupa3");
            options.headers = headers;
            
            options.responseType = responseType;            
            
            options.withCredentials = true;
            this.httpClient.get(environment.URL_API_BACKEND + url, options).subscribe(
                (response) => {
                    resolve({data: response, error: null});
                },
                (error) => {
                    resolve({data: null, error: error});
                }
            );
        });
    }
    
    post(url: string, body: any, params: any|null = null, withCredentials: boolean = true, headers: HttpHeaders = new HttpHeaders()): Promise<ApiResponse>{
        return new Promise((resolve) => {
            let options:any = {};
            if(!params){
                params = {};
            }
            params.language = this.setParamLanguage();
            options.params = params;      
            
            if(withCredentials && !headers.has("Authorization")){
                if(!this.loggedUserService.jwtToken){
                    resolve({data: null, error: true});
                    return;
                }
                headers = headers.append("Authorization", "Bearer " + this.loggedUserService.jwtToken);
            }
            headers = headers.append("X-APP-CODE","locupa3");
            options.headers = headers;
            
            options.withCredentials = true;
            this.httpClient.post(environment.URL_API_BACKEND + url, body, options).subscribe(
                (response) => {
                    resolve({data: response, error: null});
                },
                (error) => {
                    resolve({data: null, error: error});
                }
            );
        });
    }
    
    put(url: string, body: any, params: any|null = null, withCredentials: boolean = true, headers: HttpHeaders = new HttpHeaders()): Promise<ApiResponse>{
        return new Promise((resolve) => {
            let options:any = {};
            if(!params){
                params = {};
            }
            params.language = this.setParamLanguage();
            options.params = params;      
            
            if(withCredentials && !headers.has("Authorization")){
                if(!this.loggedUserService.jwtToken){
                    resolve({data: null, error: true});
                    return;
                }
                headers = headers.append("Authorization", "Bearer " + this.loggedUserService.jwtToken);
            }
            headers = headers.append("X-APP-CODE","locupa3");
            options.headers = headers;
            
            options.withCredentials = true;
            this.httpClient.put(environment.URL_API_BACKEND + url, body, options).subscribe(
                (response) => {
                    resolve({data: response, error: null});
                },
                (error) => {
                    resolve({data: null, error: error});
                }
            );
        });
    }
    
    delete(url: string, params: any|null = null, withCredentials: boolean = true, headers: HttpHeaders = new HttpHeaders()): Promise<ApiResponse>{
        return new Promise((resolve) => {
            let options:any = {};
            if(!params){
                params = {};
            }
            params.language = this.setParamLanguage();
            options.params = params;      
            
            if(withCredentials && !headers.has("Authorization")){
                if(!this.loggedUserService.jwtToken){
                    resolve({data: null, error: true});
                    return;
                }
                headers = headers.append("Authorization", "Bearer " + this.loggedUserService.jwtToken);
            }
            headers = headers.append("X-APP-CODE","locupa3");
            options.headers = headers;
            
            options.withCredentials = true;
            this.httpClient.delete(environment.URL_API_BACKEND + url, options).subscribe(
                (response) => {
                    resolve({data: response, error: null});
                },
                (error) => {
                    resolve({data: null, error: error});
                }
            );
        });
    }
    
    setParamLanguage(){
        return (this.languagesService.actualLanguage ? this.languagesService.actualLanguage.short_code : this.languagesService.defaultLanguage);
    }
    
    toQueryParams(params: any): string{
        let searchParams = new URLSearchParams();
        Object.keys(params).forEach((key) => {
            let value = params[key];
            if(typeof value !== 'string' || typeof value !== 'number' || typeof value !== 'boolean'){
                value = JSON.stringify(value);
            }
            searchParams.append(key, value);
        });
        return searchParams.toString();
    }
}
